<template>
  <div>
    <CodeDiff :old-string="oldString" :new-string="newString" :context="context" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { CodeDiff } from 'v-code-diff';

interface Props {
  oldString: string;
  newString: string;
  context: number;
}

defineProps<Props>();
const emit = defineEmits(['CodeDiffMounted']);

onMounted(async () => {
  emit('CodeDiffMounted');
});
</script>
